import * as React from "react";
import type { SVGProps } from "react";
const SvgCoinCountdownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="coin_countdown_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M213.333 85.333a42.667 42.667 0 0 0 0 85.334H256v154.24a128 128 0 0 0 23.467 73.813l77.61 109.995a42.667 42.667 0 0 1 0 49.237l-77.653 109.995A128 128 0 0 0 256 741.76v111.573h-42.667a42.667 42.667 0 1 0 0 85.334h597.334a42.667 42.667 0 1 0 0-85.334H768V741.76a128 128 0 0 0-23.467-73.813l-77.61-109.995a42.667 42.667 0 0 1 0-49.237l77.653-109.995A128 128 0 0 0 768 324.907v-154.24h42.667a42.667 42.667 0 1 0 0-85.334H213.333zm469.334 85.334V256H341.333v-85.333h341.334zm-3.286 170.666a42.539 42.539 0 0 1-4.522 8.192L597.205 459.52a128 128 0 0 0 0 147.627l48.64 68.949h-267.69l48.64-68.95a128 128 0 0 0 0-147.626l-77.611-109.995a42.667 42.667 0 0 1-4.565-8.192H679.38zm3.286 420.096v91.904H341.333V761.43h341.334z"
    />
  </svg>
);
export default SvgCoinCountdownIcon;
